import { useRef, useState } from 'react';
import { Component as FavoriteIcon } from 'icons/icon-circle--favorite.svg';
import { Component as FilledFavoriteIcon } from 'icons/icon-circle--favorite-filled.svg';
import { Component as CheckIcon } from 'icons/icon-ui--check.svg';
import { useMenuWithCart } from '../../contexts/MenuWithCart';
import styles from './Favorite.module.scss';

type Props = {
  isFavorite: boolean;
  skuId: number;
  onClick?: () => void;
};

export function Favorite({
  isFavorite,
  skuId,
  onClick,
}: Props) {
  const {
    addFavorite,
    removeFavorite,
  } = useMenuWithCart();
  const [confirmation, setConfirmation] = useState<string | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const showConfirmation = (message: string) => {
    setConfirmation(message);

    timeoutRef.current = setTimeout(() => {
      setConfirmation(null);
    }, 1000);
  };

  const handleClick = async (e: React.MouseEvent) => {
    e.stopPropagation();

    showConfirmation(isFavorite ? 'Removed from Favorites' : 'Added to Favorites');

    const action = isFavorite ? removeFavorite : addFavorite;
    await action(skuId);

    setTimeout(() => {
      onClick?.();
    }, 1200);
  };

  return (
    <div
      className={`${styles.favorite_wrapper} ${confirmation ? styles.expanded : ''}`}
      onClick={handleClick}
    >
      <div className={styles.favorite_icon}>
        {isFavorite ? <FilledFavoriteIcon fill="white" /> : <FavoriteIcon />}
      </div>
      <div className={styles.confirmation}>
        {confirmation && (<CheckIcon className="c-svg-fill-white-color" width="20" />)}
        {confirmation}
      </div>
    </div>
  );
}
